import validate from "/home/runner/work/my-mr-lite/my-mr-lite/node_modules/.pnpm/nuxt@3.20.1_prdkoepxw35unki6pbkcw3ilmq/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45check_45apex_45domain_45global from "/home/runner/work/my-mr-lite/my-mr-lite/middleware/01.checkApexDomain.global.ts";
import _02_45set_45admin_45api_45token_45global from "/home/runner/work/my-mr-lite/my-mr-lite/middleware/02.setAdminApiToken.global.ts";
import _03_45setup_45gql_45client_45global from "/home/runner/work/my-mr-lite/my-mr-lite/middleware/03.setupGqlClient.global.ts";
import _04_45load_45account_45global from "/home/runner/work/my-mr-lite/my-mr-lite/middleware/04.loadAccount.global.ts";
import _05_45set_45mr_45api_45token_45global from "/home/runner/work/my-mr-lite/my-mr-lite/middleware/05.setMrApiToken.global.ts";
import _06_45generate_45meilisearch_45tenant_45token_45global from "/home/runner/work/my-mr-lite/my-mr-lite/middleware/06.generateMeilisearchTenantToken.global.ts";
import manifest_45route_45rule from "/home/runner/work/my-mr-lite/my-mr-lite/node_modules/.pnpm/nuxt@3.20.1_prdkoepxw35unki6pbkcw3ilmq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45check_45apex_45domain_45global,
  _02_45set_45admin_45api_45token_45global,
  _03_45setup_45gql_45client_45global,
  _04_45load_45account_45global,
  _05_45set_45mr_45api_45token_45global,
  _06_45generate_45meilisearch_45tenant_45token_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}